import { bindKeysForVimCommands } from "./vim_command_mode.js";
function isTextInputTarget(target) {
    if (!(target instanceof HTMLElement)) {
        return false;
    }
    return (target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.tagName === "SELECT" ||
        target.isContentEditable);
}
export function bindKeysForShortcutHelper() {
    const helpLink = document.getElementById("less-help-link");
    const offerLink = document.getElementById("offer-link");
    const commandResultBody = document.getElementById("less-command-result-body");
    const manualScrollArea = document.getElementById("manual-scroll-area");
    const commandController = bindKeysForVimCommands({
        onUnknownCommand: () => {
            flashPct("?");
        },
    });
    const pctEl = document.getElementById("scroll-pct");
    const updatePct = () => {
        if (!pctEl) {
            return;
        }
        const total = manualScrollArea
            ? manualScrollArea.scrollHeight - manualScrollArea.clientHeight
            : document.documentElement.scrollHeight - window.innerHeight;
        if (total <= 0) {
            pctEl.textContent = "END";
            return;
        }
        const current = manualScrollArea
            ? manualScrollArea.scrollTop
            : window.scrollY;
        const pct = Math.round((current / total) * 100);
        pctEl.textContent = pct >= 100 ? "END" : `${pct}%`;
    };
    updatePct();
    const lineStep = 44;
    const page = () => window.innerHeight * 0.88;
    const flashPct = (text) => {
        if (!pctEl) {
            return;
        }
        pctEl.textContent = text;
        updatePct();
    };
    const isResultOverlayVisible = () => document.body.classList.contains("command-result-open");
    const scrollMainBy = (top) => {
        if (manualScrollArea) {
            manualScrollArea.scrollBy({ top, behavior: "auto" });
            return;
        }
        window.scrollBy(0, top);
    };
    const scrollMainTo = (top) => {
        if (manualScrollArea) {
            manualScrollArea.scrollTo({ top, behavior: "auto" });
            return;
        }
        window.scrollTo(0, top);
    };
    const getMainScrollHeight = () => manualScrollArea?.scrollHeight ?? document.body.scrollHeight;
    const scrollResultBy = (top) => {
        if (!(commandResultBody instanceof HTMLElement)) {
            return;
        }
        commandResultBody.scrollBy({ top, behavior: "auto" });
    };
    const scrollResultTo = (top) => {
        if (!(commandResultBody instanceof HTMLElement)) {
            return;
        }
        commandResultBody.scrollTo({ top, behavior: "auto" });
    };
    const onManualWheel = (event) => {
        if (!manualScrollArea || isResultOverlayVisible()) {
            return;
        }
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }
        if (!target.closest("pre")) {
            return;
        }
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) {
            return;
        }
        event.preventDefault();
        scrollMainBy(event.deltaY);
    };
    const onHelpLinkClick = (event) => {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent("hub-for-programmers:run-command", {
            detail: "help",
        }));
    };
    helpLink?.addEventListener("click", onHelpLinkClick);
    const onOfferLinkClick = (event) => {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent("hub-for-programmers:run-command", {
            detail: "offer",
        }));
    };
    offerLink?.addEventListener("click", onOfferLinkClick);
    const onKeydown = (event) => {
        if (isTextInputTarget(event.target)) {
            return;
        }
        if (event.metaKey || event.ctrlKey || event.altKey) {
            return;
        }
        if (commandController.handleKeydown(event)) {
            return;
        }
        if (isResultOverlayVisible()) {
            switch (event.key) {
                case "j":
                case "ArrowDown":
                    event.preventDefault();
                    scrollResultBy(lineStep);
                    break;
                case "k":
                case "ArrowUp":
                    event.preventDefault();
                    scrollResultBy(-lineStep);
                    break;
                case "PageDown":
                case " ":
                case "f":
                case "F":
                    event.preventDefault();
                    scrollResultBy(page());
                    break;
                case "b":
                case "PageUp":
                    event.preventDefault();
                    scrollResultBy(-page());
                    break;
                case "g":
                case "Home":
                    event.preventDefault();
                    scrollResultTo(0);
                    break;
                case "G":
                case "End":
                    event.preventDefault();
                    scrollResultTo(commandResultBody?.scrollHeight ?? 0);
                    break;
            }
            return;
        }
        switch (event.key) {
            case "j":
            case "ArrowDown":
                event.preventDefault();
                scrollMainBy(lineStep);
                break;
            case "k":
            case "ArrowUp":
                event.preventDefault();
                scrollMainBy(-lineStep);
                break;
            case "PageDown":
                event.preventDefault();
                scrollMainBy(page());
                break;
            case "b":
                event.preventDefault();
                scrollMainBy(-page());
                break;
            case "PageUp":
                event.preventDefault();
                scrollMainBy(-page());
                break;
            case "g":
                event.preventDefault();
                scrollMainTo(0);
                flashPct("TOP");
                break;
            case "Home":
                event.preventDefault();
                scrollMainTo(0);
                flashPct("TOP");
                break;
            case "G":
                event.preventDefault();
                scrollMainTo(getMainScrollHeight());
                break;
            case "End":
                event.preventDefault();
                scrollMainTo(getMainScrollHeight());
                break;
            case " ":
            case "f":
            case "F":
                event.preventDefault();
                scrollMainBy(page());
                break;
        }
    };
    document.addEventListener("keydown", onKeydown);
    manualScrollArea?.addEventListener("wheel", onManualWheel, {
        passive: false,
    });
    let scrollTicking = false;
    const onScroll = () => {
        if (scrollTicking) {
            return;
        }
        scrollTicking = true;
        requestAnimationFrame(() => {
            updatePct();
            scrollTicking = false;
        });
    };
    const scrollTarget = manualScrollArea ?? window;
    scrollTarget.addEventListener("scroll", onScroll, { passive: true });
    return () => {
        helpLink?.removeEventListener("click", onHelpLinkClick);
        offerLink?.removeEventListener("click", onOfferLinkClick);
        document.removeEventListener("keydown", onKeydown);
        manualScrollArea?.removeEventListener("wheel", onManualWheel);
        scrollTarget.removeEventListener("scroll", onScroll);
    };
}
